module.exports = __webpack_public_path__ + "img/proyecto_18.22540348.webp";